import { Availability } from "../Availability";
export class QrWaiterPurchaseOrderFulfillmentTime {
    constructor() {
        this.type = "QrWaiter";
        // TODO: Can we place order with preorder items via QR waiter?
        this.isPreorder = false;
    }
    get availability() {
        return Availability.available();
    }
}
